import styled from "@emotion/styled";

export const EmptyStateIconForeground = styled.path`
  fill: var(--mb-color-bg-light);
  stroke: var(--mb-color-brand);
`;

export const EmptyStateIconBackground = styled.path`
  fill: var(--mb-color-brand-light);
  stroke: var(--mb-color-brand);
`;
